<h1 mat-dialog-title *transloco="let t">{{t('warning')}}</h1>
<div mat-dialog-content *transloco="let t">
    <p>{{t('browser.go.back')}}</p>
</div>
<div mat-dialog-actions *transloco="let t">
    <button mat-button (click)="closeDialog(true)">{{t('btn.confirm')}}</button>
    <button mat-button (click)="closeDialog(false)">{{t('btn.cancel')}}</button>
</div>